import { useState, useEffect, useContext } from "react";
import { channelFetcher, playlistFetcher } from "../../api/requests";
import { Link } from "react-router-dom";
import { Button, Spinner, Form } from "react-bootstrap";
import { baseURL } from "../../api/dataFetcher";
import { AuthContext } from "../../context/auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useToaster } from "../../context/toaster";
import Modal from "../Atomics/Modal";

const Playlist = ({ id }) => {
  const [playlist, setPlaylist] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isPlaylistLoading, setIsPlaylistLoading] = useState(true);
  const [isVideosLoading, setIsVideosLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const { user } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    package_name: "",
    package_description: "",
    play_list_videos: [],
    channel: id,
    creator: user.user_id,
  });
  const [videos, setVideos] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [showDelModal, setShowDelModal] = useState(false);
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const { addMessage } = useToaster();
  const [isOwnerOrAdmin, setIsOwnerOrAdmin] = useState({
    is_owner: false,
    is_admin: false,
  });
  const [editMode, setEditMode] = useState(false);
  const [editingPlaylistId, setEditingPlaylistId] = useState(null);

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const getPlaylist = async () => {
    setIsPlaylistLoading(true);
    try {
      const data = await playlistFetcher.get(id);
      setPlaylist(data);
    } catch (err) {
      console.error(err);
    } finally {
      setIsPlaylistLoading(false);
    }
  };

  const handleEditPlaylist = (playlist) => {
    setEditMode(true);
    setEditingPlaylistId(playlist.id);
    setFormData({
      package_name: playlist.package_name,
      package_description: playlist.package_description,
      play_list_videos: playlist.play_list_videos.map((v) => String(v.id)),
      channel: id,
      creator: user.user_id,
    });
    setShowForm(true);
  };

  const getChannelsVideos = async () => {
    setIsVideosLoading(true);
    try {
      const data = await channelFetcher.getChannelsVideos({
        id: id,
        page_size: 10000,
      });
      setVideos(data);
    } catch (error) {
      console.error("Failed to fetch playlist:", error);
    } finally {
      setIsVideosLoading(false);
    }
  };

  const getIsOwnerOrAdmin = async () => {
    const res = await channelFetcher.isChannelsOwnerOrAdmin(id, user.user_id);

    setIsOwnerOrAdmin(res);
  };

  useEffect(() => {
    getPlaylist();
    getChannelsVideos();
    getIsOwnerOrAdmin();
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      if (editMode && editingPlaylistId) {
        await playlistFetcher.put(editingPlaylistId, formData);
        showToast("success", "لیست پخش با موفقیت ویرایش شد.");
      } else {
        await playlistFetcher.post(formData);
        showToast("success", "لیست پخش با موفقیت ایجاد شد.");
      }
      setShowForm(false);
      setEditMode(false);
      setEditingPlaylistId(null);
      getPlaylist();
    } catch (error) {
      console.error("Failed to save playlist:", error);
      showToast("error", "عملیات ناموفق بود.");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePlayListDelete = (id) => {
    setShowDelModal(true);
    setSelectedPlaylist(id);
  };

  const approveDelete = async () => {
    setIsLoading(true);
    try {
      const res = await playlistFetcher.delete(selectedPlaylist);

      setShowDelModal(false);

      if (res) showToast("success", "لیست پخش با موفقیت حذف شد.");

      getPlaylist();
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "140px",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        paddingRight: "30px",
        justifyContent: isVideosLoading ? "center" : "flex-start",
        alignItems: isVideosLoading ? "center" : "stretch",
        marginTop: "25px",
      }}
    >
      {(isOwnerOrAdmin.is_owner || isOwnerOrAdmin.is_admin) && (
        <Button
          id="playlistCreation"
          style={{ width: "fit-content" }}
          onClick={() => {
            setShowForm(!showForm);
            setFormData({
              package_name: "",
              package_description: "",
              play_list_videos: [],
              channel: id,
              creator: user.user_id,
            });
          }}
        >
          افزودن لیست پخش
        </Button>
      )}

      {showForm && (
        <Form
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            maxWidth: "400px",
            textAlign: "right",
          }}
          onSubmit={handleSubmit}
        >
          <Form.Group>
            <Form.Label>نام لیست پخش</Form.Label>
            <Form.Control
              type="text"
              name="package_name"
              value={formData.package_name}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>توضیحات</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="package_description"
              value={formData.package_description}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>انتخاب ویدئوها</Form.Label>

            {/* Search bar */}
            <Form.Control
              type="text"
              placeholder="جستجو ویدئو..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ marginBottom: "10px" }}
            />

            {/* Scrollable list with checkboxes */}
            <div style={{ maxHeight: "200px", overflowY: "auto" }}>
              {isVideosLoading ? (
                <Spinner animation="border" role="status"></Spinner>
              ) : videos?.results?.length > 0 ? (
                videos?.results
                  ?.filter((video) =>
                    video.title.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .map((video) => (
                    <Form.Check
                      className="playListForm"
                      key={video.id}
                      type="checkbox"
                      label={video.title}
                      value={video.id}
                      checked={formData.play_list_videos.includes(
                        String(video.id)
                      )}
                      onChange={(e) => {
                        const value = e.target.value;
                        setFormData((prev) => ({
                          ...prev,
                          play_list_videos: prev.play_list_videos.includes(
                            value
                          )
                            ? prev.play_list_videos.filter((id) => id !== value)
                            : [...prev.play_list_videos, value],
                        }));
                      }}
                    />
                  ))
              ) : (
                <p>ویدئوای وجود ندارد.</p>
              )}
            </div>
          </Form.Group>

          <Button type="submit">
            {isLoading ? "لطفا منتظر بمانید..." : editMode ? "ویرایش" : "ذخیره"}
          </Button>
        </Form>
      )}
      {isPlaylistLoading ? (
        <Spinner animation="border" role="status"></Spinner>
      ) : playlist?.results?.length > 0 ? (
        playlist.results.map((item, index) => (
          <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            {(isOwnerOrAdmin.is_owner || isOwnerOrAdmin.is_admin) && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "3px",
                  alignItems: "center",
                }}
              >
                <button
                  className="adminBtnEdit"
                  style={{ height: "20px", width: "22px" }}
                  onClick={() => handleEditPlaylist(item)}
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                <button
                  className="adminBtnDelete"
                  style={{ height: "20px", width: "22px", marginRight: "0px" }}
                  onClick={() => handlePlayListDelete(item.id)}
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>
            )}

            <Link
              key={index}
              to={`/playlist/${item.id}/`}
              className="nav-link playlistContainer"
            >
              <img
                src={
                  item?.play_list_videos[0]?.cover
                    ? baseURL + item?.play_list_videos[0]?.cover
                    : "/img/s1.png"
                }
                alt=""
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  textAlign: "right",
                }}
              >
                <div
                  style={{ display: "flex", gap: "5px", alignItems: "center" }}
                >
                  <strong>{item?.package_name}</strong>
                  <small
                    style={{
                      color: "#dfb46a",
                      backgroundColor: "#f0f0f0ff",
                      padding: "0px 5px",
                      borderRadius: "5px",
                    }}
                  >
                    <strong>{item?.play_list_videos?.length} ویدئو</strong>
                  </small>
                </div>

                <span>{item?.package_description}</span>
              </div>
            </Link>
          </div>
        ))
      ) : (
        <p style={{ textAlign: "right", marginTop: "25px" }}>
          لیست پخش وجود ندارد.
        </p>
      )}

      <Modal isOpen={showDelModal} onClose={() => setShowDelModal(false)}>
        <p style={{ paddingTop: "15px", fontSize: "18px", width: "100%" }}>
          از حذف این آیتم مطمئن هستید؟
        </p>
        <div style={{ display: "flex", gap: "5px", width: "100%" }}>
          <Button
            style={{
              fontSize: "15px",
              padding: "2px 8px",
              height: "fit-content",
            }}
            onClick={() => approveDelete()}
          >
            {isLoading ? "لطفا منتظر بمانید..." : "بله"}
          </Button>
          <Button
            style={{
              fontSize: "15px",
              padding: "2px 8px",
              height: "fit-content",
            }}
            variant="danger"
            onClick={() => setShowDelModal(false)}
          >
            خیر
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default Playlist;
